<div class="container-fluid h-100 login-form-wrapper">
  <button
    class="login-theme-toggle"
    type="button"
    (click)="toggleTheme()"
    [title]="theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
    [attr.aria-label]="
      theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'
    "
  >
    @if (theme === "dark") {
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="4" />
        <path
          d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
        />
      </svg>
    }
    @if (theme === "light") {
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M21 13a9 9 0 11-10-10 7 7 0 0010 10z" />
      </svg>
    }
  </button>

  <div class="logo-container">
    <div class="logo">
      <img
        [src]="
          theme === 'light'
            ? '../../../assets/images/logo-purple.svg'
            : '../../../assets/images/logo-white.svg'
        "
        alt="Cimalti"
      />
    </div>
  </div>
  <div class="card login-card">
    <div class="card-body">
      <form
        name="form"
        (ngSubmit)="loginForm.form.valid && onLoginFormSubmit()"
        #loginForm="ngForm"
        class="form-content"
      >
        @if (!qrCodeSrc && !showOtpField) {
          <div class="form-content w-100">
            <h1>Login to Client Portal</h1>
            <mat-form-field appearance="outline" class="w-100">
              <input
                matInput
                placeholder="Email"
                name="email"
                [(ngModel)]="guest.email"
                #email="ngModel"
                required
                email
              />
              @if (loginForm.submitted && email.invalid) {
                <mat-error>Email must be a valid email address</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <input
                matInput
                [type]="hidePwd ? 'password' : 'text'"
                placeholder="Password"
                [(ngModel)]="guest.password"
                name="password"
                #password="ngModel"
                required
              />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="hidePwd = !hidePwd"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hidePwd"
              >
                <mat-icon>{{
                  hidePwd ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
              @if (loginForm.submitted && password.invalid) {
                <mat-error>Password is required</mat-error>
              }
            </mat-form-field>
            <button
              mat-flat-button
              color="primary"
              class="btn-wide rounded-pill"
            >
              <span class="navigation-button">Login</span>
            </button>
            <a
              mat-button
              routerLink="password-reset"
              class="forgot-pwd-link text-400"
              color="primary"
              >Forgot your password?</a
            >
            <span class="version-text">{{ version }}</span>
          </div>
        }

        @if (qrCodeSrc) {
          <div class="form-content w-100 text-center">
            <h3>Setup One Time Password</h3>
            <p>Scan the QR code with <b>Google Authenticator</b> app.</p>
            <img src="{{ qrCodeSrc }}" alt="" class="mb-5" />
            <div>
              <button
                mat-flat-button
                color="primary"
                class="btn-wide rounded-pill"
                (click)="onOtpSetupFinished()"
              >
                Finish setup
              </button>
            </div>
          </div>
        }

        @if (showOtpField) {
          <div class="form-content w-100 text-center">
            <h1>Verify it’s you</h1>
            <p class="mb-5">
              Please enter your authentication code in the field below.
            </p>
            <mat-form-field appearance="outline" class="w-100">
              <input
                matInput
                placeholder="Code"
                name="otp"
                [(ngModel)]="guest.otp"
                #otp="ngModel"
              />
              @if (otp.dirty && otp.invalid) {
                <mat-error>One time password is required</mat-error>
              }
            </mat-form-field>
            <div class="d-block text-center">
              <p>
                <button
                  mat-flat-button
                  color="primary"
                  class="btn-wide rounded-pill"
                >
                  Submit
                </button>
              </p>
              <p>
                <button
                  type="button"
                  (click)="onReset2FAClick()"
                  mat-button
                  color="primary"
                  class=""
                >
                  Send code via email
                </button>
              </p>
            </div>
          </div>
        }
      </form>
    </div>
  </div>
</div>
